<template>
  <Chart
    type="pie"
    :width="width"
    :height="height"
    :data="data"
    :options="options"
  />
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useStore } from "@/store";

export default defineComponent({
  props: {
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    labels: {
      type: Array
    },
    chartData: {
      type: Array
    }
  },
  setup(props) {
    const store = useStore();
    const darkMode = computed(() => store.state.main.darkMode);
    const data = computed(() => {
      return {
        labels: ["Ký nhận", "Chưa ký nhận","Chuyển hoàn"],
        datasets: [
          {
            data: props.chartData,
            backgroundColor: ["#91C714", "#D32929", "#FBC500"],
            hoverBackgroundColor: ["#91C714", "#D32929", "#FBC500"],
            borderWidth: 5,
            borderColor: darkMode.value ? "#303953" : "#fff",
          },
        ],
      };
    });
    const options = computed(() => {
      return {
        legend: {
          display: false,
        },
      };
    });

    return {
      data,
      options,
    };
  },
});
</script>
